export default __webpack_public_path__ + "static/media/dual.75335d85.jpg";